var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useModal } from 'root/src/client/v2/common/contexts/modal.context';
import { useMutation } from '@tanstack/react-query';
import { useDareDropApi } from 'root/src/client/v2/common/hooks/useDareDropApi';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { downloadFile } from 'root/src/client/v2/common/helpers/downloadFile';
import { dropReportsEndpointIds } from 'root/src/shared/dropReports/dropReports.constants';
import toast from 'react-hot-toast';
export function useDownloadCampaignReportFormProvider(params) {
    const { hide } = useModal();
    const downloadCampaignReport = useDownloadCampaignReportMutation();
    const form = useDownloadCampaignReportForm({
        defaultValues: {
            dropId: (params === null || params === void 0 ? void 0 : params.dropId) || '',
            isReportByGame: false,
            isEmailReport: false,
            to: params === null || params === void 0 ? void 0 : params.to,
            from: params === null || params === void 0 ? void 0 : params.from,
            linkedDrops: [],
        },
    });
    const onFormSubmit = form.handleSubmit((data) => __awaiter(this, void 0, void 0, function* () {
        try {
            const linkedDrops = (data.linkedDrops).map((drop) => {
                return {
                    dropId: drop.id,
                    from: drop === null || drop === void 0 ? void 0 : drop.from,
                    to: drop === null || drop === void 0 ? void 0 : drop.to,
                    excludeWhitelistedCreators: params === null || params === void 0 ? void 0 : params.excludeWhitelistedCreators,
                    onlyEarnedPointsCreators: params === null || params === void 0 ? void 0 : params.onlyEarnedPointsCreators,
                };
            });
            const reportFiles = yield downloadCampaignReport.mutateAsync({
                dropParams: [
                    {
                        dropId: data.dropId,
                        from: data.from,
                        to: data.to,
                        excludeWhitelistedCreators: params === null || params === void 0 ? void 0 : params.excludeWhitelistedCreators,
                        onlyEarnedPointsCreators: params === null || params === void 0 ? void 0 : params.onlyEarnedPointsCreators,
                    },
                    ...linkedDrops,
                ],
                isReportByGame: data.isReportByGame,
                isEmailReport: data.isEmailReport,
            });
            if (reportFiles === null || reportFiles === void 0 ? void 0 : reportFiles.length) {
                reportFiles.map(fileUrl => downloadFile(fileUrl));
            }
            else {
                toast.success('Report will be emailed to you shortly.');
            }
            hide();
        }
        catch (err) {
            console.error(err);
        }
    }), (errors) => {
        console.error(errors);
        toast.error('Please fix the errors in the form before submitting.');
    });
    return Object.assign(Object.assign({}, form), { handleSubmit: onFormSubmit });
}
export const downloadCampaignFormSchema = z.object({
    dropId: z.string().min(1, 'Campaign is required'),
    isReportByGame: z.boolean().optional(),
    isEmailReport: z.boolean().optional(),
    to: z.string().optional(),
    from: z.string().optional(),
    linkedDrops: z.object({
        id: z.string(),
        from: z.string().optional(),
        to: z.string().optional(),
        title: z.string(),
        liveDate: z.string(),
        expirationDate: z.string(),
    }).array(),
});
function useDownloadCampaignReportForm(params) {
    return useForm(Object.assign(Object.assign({}, params), { resolver: zodResolver(downloadCampaignFormSchema) }));
}
function useDownloadCampaignReportMutation() {
    const { fetcher } = useDareDropApi();
    return useMutation({
        mutationKey: [],
        mutationFn: (params) => __awaiter(this, void 0, void 0, function* () {
            return fetcher({
                endpointId: dropReportsEndpointIds.GENERATE_DROP_REPORT,
                payload: params,
            });
        }),
    });
}
